import React, { useEffect, useRef, useState } from "react"
import swal from 'sweetalert';
import { useDispatch, useSelector } from "react-redux";
import { setActiveModalAction } from "../../action";
import { withRouter } from 'react-router-dom';
import { modalsSelector } from "../../selectors";
import { useOnClickOutside } from "../../hooks";
import { changeActivateWorkingShift } from "../../action/cassa";
import { styles } from "../goods/styles";

const WorkingShiftModal = (props) => {
    const inital = useSelector(modalsSelector).workingShiftModal;
    const loading = useSelector(state =>  state.loaders.workingShift);
    const { id, point } = inital;
    const [sendKKT, setSendKKT] = useState(true);

    useEffect(() => {
        if (!loading) return;
      
        const handleBeforeUnload = (e) => {
          e.preventDefault();
          e.returnValue = 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
          return e.returnValue;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
      
        const unblock = props.history.block((location, action) => {
          return 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
        });
      
        return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload);
          if (unblock) unblock();
        };
    }, [loading, props.history]);
    
    const ref = useRef();
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(setActiveModalAction({ field: 'workingShiftModal', value: null }));
    };

    const changeActivate = async () => {    
        if(!point) {
            return swal({
                title: 'Ошибка',
                text: 'Не обнаружен филиал.',
                icon: 'error',
                button: 'Oк'
            });
        }
    
        const result = await dispatch(changeActivateWorkingShift(id, point, sendKKT));
        if(result.error || !result || !result.message) {
            let errorText = '';
            if (result.error && result.error.description) errorText += result.error.description;
            if (result.error && result.error.message) errorText += result.error.message;
            return swal({
                title: `Ошибка ${id ? 'закрытия' : 'открытия'} смены`,
                text: `${result.error.code ? `Код ошибки: ${result.error.code}. ` : ''}${errorText}`,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
        
        return swal({
            title: result.message ? result.message : '',
            icon: "success",
            button: "Ок",
        }).then(() => onClose());
    };
    
    useOnClickOutside(ref, onClose);

    if (loading) return (
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                        <div style={{...styles.tableLoading, marginTop: 100}}>
                            <div className="loader">
                                <div className="kt-spinner kt-spinner--lg kt-spinner--info">
                                </div>
                            </div>
                        </div>
                            <div style={{ color: 'black', fontSize: '1.3rem' }}>{sendKKT ? 'Ожидаем ответ от ККТ. Не закрывайте и не обновляйте страницу' : 'Загрузка данных. Не закрывайте и не обновляйте страницу'}</div>          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    return(
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={ref} className="modal-content" style={{ maxWidth: '500px' }}>
                        <div className="modal-header">
                          <div>
                            <h5 className="modal-title"> {id ? 'Закрытие смены' : 'Открытие смены'} </h5>
                          </div>
                            <button disabled={loading} onClick={onClose} type="button" className="close"></button>
                        </div>
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div>
                                <span style={{ color: 'red', textAlign: 'center' }}>{id ? 'Внимание, закрывая смену вы блокируете все заказы в пределах смены, изменить, удалить, поставить оплату будет нельзя. Выполните все нужные операции с заказами до закрытия смены. Закрытие смены нельзя отменить! ' : ''}</span>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                <input type="checkbox" disabled={loading} checked={sendKKT}  onChange={() => setSendKKT(!sendKKT)} />
                                <span style={{ color: '#000', textAlign: 'center' }}>{id ? 'Закрыть смену в ККТ и распечатать Z-отчет.' : 'Открыть смену в ККТ.'}</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button disabled={loading} type="button" className="btn btn-primary" onClick={changeActivate}>{id ? 'Закрыть' : 'Открыть'}</button>
                            <button disabled={loading} type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(WorkingShiftModal);